<template>

  <div class="w-full absolute -top-[22px] start-0 end-0 px-[13px]" id="pickup">
    <div class="h-[164px] rounded-b-[26px] flex items-end justify-start" :class="{ 'bg-[#C6BA88]' : status === 1, 'bg-[#C3785F]' : status === 2, 'bg-[#BC9D7F]' : status === 3, 'bg-[#D5E0E2]' : status === 4 }">
    <div class="ps-[28px] pb-[30px]">
      <div class="text-[37px] font-bold" :class="{ 'text-[#3E5463]' : status === 4, 'text-white' : status !==4 }">
        {{lang === 'en' ? 'Track Order' : 'تتبع الطلب'}}
      </div>
    <div class="text-[20px] font-bold -mt-[10px]" :class="{ 'text-[#3E5463]' : status === 4, 'text-white' : status !== 4 }">
      {{lang === 'en' ? 'ORDER' : 'طلب'}} # 11668455
    </div>
  </div>
  </div>
  </div>
  <div class="bg-[#798B97] h-[calc(100vh-92px)] w-full rounded-[20px] pt-[11px] overflow-auto scrollbar">
    <div class="text-[24px] text-center font-bold pt-[150px] text-white uppercase"> {{lang === 'en' ? 'STATUS' : 'حالة'}} </div>
    <div class="text-[31px] text-center font-bold text-white uppercase mb-[10px]">
      <template v-if="status === 1"> {{lang === 'en' ? 'placed' : 'وضعت'}} </template>
      <template v-if="status === 2"> {{lang === 'en' ? 'in the range' : 'في النطاق'}} </template>
      <template v-if="status === 3"> {{lang === 'en' ? 'Order preparing' : 'تحضير الطلب'}} </template>
      <template v-if="status === 4"> {{lang === 'en' ? 'Picked up' : 'التقطت'}} </template>
    </div>
    <div class="px-[16px] mb-[19px]">
      <div class="h-[72px] w-full bg-white p-5 flex justify-between items-center rounded-[8px]">

        <button type="button" class="border-0 outline-0 bg-[#C1D5E5] flex justify-center items-center size-[52px] rounded-[9px]" @click="status = 1">
          <svg xmlns="http://www.w3.org/2000/svg" width="33.044" height="33.043" viewBox="0 0 33.044 33.043">
            <g id="svgexport-6_33_" data-name="svgexport-6 (33)" transform="translate(0 0)">
              <g id="Line" transform="translate(0 0)">
                <path id="Path_97" data-name="Path 97" d="M31.989,35.293H12.764a3.3,3.3,0,0,1-3.3-3.3v-.541a9.312,9.312,0,0,1,0-18.143V5.554a3.3,3.3,0,0,1,3.3-3.3H26.185a3.292,3.292,0,0,1,2.343.973L34.32,9.015a3.292,3.292,0,0,1,.973,2.4V31.988A3.3,3.3,0,0,1,31.989,35.293Zm-20.727-3.6v.3a1.5,1.5,0,0,0,1.5,1.5H31.989a1.5,1.5,0,0,0,1.5-1.5V12.463H28.384a3.3,3.3,0,0,1-3.3-3.3V4.052H12.764a1.5,1.5,0,0,0-1.5,1.5v7.51h.3a9.312,9.312,0,1,1,0,18.624Zm.3-16.822a7.51,7.51,0,1,0,7.51,7.51,7.51,7.51,0,0,0-7.51-7.51ZM26.882,4.221V9.159a1.5,1.5,0,0,0,1.5,1.5h4.938a1.67,1.67,0,0,0-.276-.372L27.254,4.5a1.67,1.67,0,0,0-.372-.276Zm2.7,22.661H23.578a.9.9,0,1,1,0-1.8h6.008a.9.9,0,1,1,0,1.8ZM9.76,25.08a.889.889,0,0,1-.6-.3.9.9,0,0,1,0-1.2L10.7,22.04V18.771a.9.9,0,0,1,1.8,0v3.6a.9.9,0,0,1-.264.637l-1.874,1.766a.889.889,0,0,1-.6.3Zm19.826-3H24.779a.9.9,0,1,1,0-1.8h4.806a.9.9,0,1,1,0,1.8Zm0-4.806H23.578a.9.9,0,1,1,0-1.8h6.008a.9.9,0,1,1,0,1.8Zm-8.411-4.806h-3.6a.9.9,0,1,1,0-1.8h3.6a.9.9,0,1,1,0,1.8Z" transform="translate(-2.249 -2.25)" fill="#3e5463"/>
              </g>
            </g>
          </svg>
        </button>

        <div class="flex justify-center items-center text-[#3E5463]"> -<span class="hidden sm:flex justify-center">----</span> </div>

        <button type="button" :class="['border-0 outline-0 flex justify-center items-center size-[52px] rounded-[9px]', status !== 1 ? 'bg-[#C1D5E5]' : 'bg-transparent']" @click="status = 2">
        <svg id="svgexport-6_8_" data-name="svgexport-6 (8)" xmlns="http://www.w3.org/2000/svg" width="39.718" height="14.844" viewBox="0 0 39.718 14.844">
          <g id="Group_27" data-name="Group 27" transform="translate(0 0)">
            <path id="Path_70" data-name="Path 70" d="M91.107,292.972a.58.58,0,0,0,.411-.17l.879-.879a.582.582,0,0,0-.823-.823l-.879.88a.582.582,0,0,0,.411.993Z" transform="translate(-83.503 -280.797)" fill="#3e5463"/>
            <path id="Path_71" data-name="Path 71" d="M404.2,292.8a.582.582,0,0,0,.823-.823l-.879-.879a.582.582,0,1,0-.823.823Z" transform="translate(-371.881 -280.797)" fill="#3e5463"/>
            <path id="Path_72" data-name="Path 72" d="M37.964,166.363c-3.286-1.526-8.229-1.672-9.227-1.686l-4.714-3a8.652,8.652,0,0,0-4.652-1.355H13.83a9.335,9.335,0,0,0-4.154.981l-2.951,1.476a8.724,8.724,0,0,1-2.827.856l-2.3.287A1.828,1.828,0,0,0,0,165.734v3.713A2.458,2.458,0,0,0,1.775,171.8l2.749.785a3.69,3.69,0,0,0,6.726.716H29.09a3.694,3.694,0,1,0-.424-1.164H11.674a3.69,3.69,0,1,0-7.318-.81l-2.262-.646a1.289,1.289,0,0,1-.931-1.234v-1.742h.662a.582.582,0,1,0,0-1.164H1.164v-.808a.663.663,0,0,1,.58-.657l2.3-.287a9.886,9.886,0,0,0,3.2-.97l.265-.133,1.076,1.071a3.667,3.667,0,0,0,2.61,1.081h1.2a.582.582,0,1,0,0-1.164H11.2a2.556,2.556,0,0,1-.3-.018l.643-2.84a8.155,8.155,0,0,1,2.292-.331h2.96v3.189H14.885a.582.582,0,1,0,0,1.164H28.565c.055,0,5.552.02,8.909,1.579a1.828,1.828,0,0,1,.522.367h-.725a.582.582,0,0,0,0,1.164h1.273c.006.063.011.126.011.19V171.2c0,.576-.254.934-.662.934a.582.582,0,1,0,0,1.164,1.722,1.722,0,0,0,1.318-.6,2.244,2.244,0,0,0,.507-1.5v-2.064A3.063,3.063,0,0,0,37.964,166.363ZM32.3,168.949a2.527,2.527,0,1,1-2.527,2.527A2.53,2.53,0,0,1,32.3,168.949Zm-24.252,0a2.527,2.527,0,1,1-2.527,2.527A2.53,2.53,0,0,1,8.044,168.949Zm1.751-4.7a2.554,2.554,0,0,1-.384-.316l-.8-.8,1.585-.793.033-.016Zm8.159-2.765h1.417a7.491,7.491,0,0,1,4.028,1.173l3.169,2.016H17.954Z" transform="translate(0 -160.323)" fill="#3e5463"/>
            <path id="Path_73" data-name="Path 73" d="M168.921,280.564a.582.582,0,1,0,0,1.164H181.98a.582.582,0,1,0,0-1.164Z" transform="translate(-155.28 -271.236)" fill="#3e5463"/>
          </g>
        </svg>
        </button>

        <div class="flex justify-center items-center text-[#3E5463]"> -<span class="hidden sm:flex justify-center">----</span> </div>

        <button type="button" :class="['border-0 outline-0 flex justify-center items-center size-[52px] rounded-[9px]', status !== 1 && status !== 2 ? 'bg-[#C1D5E5]' : 'bg-transparent']" @click="status = 3">
          <svg id="svgexport-6_39_" data-name="svgexport-6 (39)" xmlns="http://www.w3.org/2000/svg" width="33.399" height="33.436" viewBox="0 0 33.399 33.436">
            <g id="Cooking" transform="translate(0)">
              <path id="Path_117" data-name="Path 117" d="M29.594,43.574c-1.895,0-.7.279-.7-1.393,0-1.351-1.888-3.525-2.271-3.95a.7.7,0,0,0-1.031,0c-.383.425-2.271,2.6-2.271,3.95a2.724,2.724,0,0,0,.39,1.393H21.542a2.724,2.724,0,0,0,.39-1.393c0-1.351-1.888-3.525-2.271-3.95a.7.7,0,0,0-1.031,0c-.383.425-2.271,2.6-2.271,3.95a2.724,2.724,0,0,0,.39,1.393H14.576a2.724,2.724,0,0,0,.39-1.393c0-1.351-1.888-3.525-2.271-3.95a.7.7,0,0,0-1.031,0c-.383.425-2.271,2.6-2.271,3.95,0,1.665,1.191,1.393-.7,1.393a.7.7,0,1,0,0,1.393h20.9a.7.7,0,0,0,0-1.393ZM24.718,42.18a6.208,6.208,0,0,1,1.393-2.4,6.357,6.357,0,0,1,1.393,2.4,1.393,1.393,0,1,1-2.786,0Zm-6.966,0a6.208,6.208,0,0,1,1.393-2.4,6.357,6.357,0,0,1,1.393,2.4,1.393,1.393,0,1,1-2.786,0Zm-6.966,0a6.208,6.208,0,0,1,1.393-2.4,6.357,6.357,0,0,1,1.393,2.4,1.393,1.393,0,1,1-2.786,0Z" transform="translate(-2.446 -11.53)" fill="#3e5463"/>
              <path id="Path_118" data-name="Path 118" d="M30.6,14H2.857a2.856,2.856,0,0,0-1.275,5.4l2.605,1.3v2.354a6.269,6.269,0,0,0,6.269,6.269H23a6.269,6.269,0,0,0,6.269-6.269V20.7l2.605-1.3A2.856,2.856,0,0,0,30.6,14ZM2.209,18.18a1.456,1.456,0,0,1,.648-2.786h1.33v3.748Zm25.662,4.876A4.876,4.876,0,0,1,23,27.932H10.457a4.876,4.876,0,0,1-4.876-4.876V15.393H27.872Zm3.372-4.876-1.978.961V15.393H30.6a1.456,1.456,0,0,1,.648,2.786Z" transform="translate(-0.027 -4.248)" fill="#3e5463"/>
              <path id="Path_119" data-name="Path 119" d="M22.943,5.963c-1.428,1.191-1.038,2.4-.251,2.4a.7.7,0,0,0,.7-.7c0-.641,1.393-.843,1.393-2.32,0-1.86-2.354-1.783-.947-2.954S24.88,0,24.086,0a.7.7,0,0,0-.7.7c0,.641-1.393.843-1.393,2.32S23.389,4.7,23.389,5.343C23.389,5.573,23.278,5.684,22.943,5.963Z" transform="translate(-6.689)" fill="#3e5463"/>
              <path id="Path_120" data-name="Path 120" d="M14.943,5.963c-1.428,1.191-1.038,2.4-.251,2.4a.7.7,0,0,0,.7-.7c0-.641,1.393-.843,1.393-2.32,0-1.86-2.354-1.783-.947-2.954S16.88,0,16.086,0a.7.7,0,0,0-.7.7c0,.641-1.393.843-1.393,2.32S15.389,4.7,15.389,5.343C15.389,5.573,15.278,5.684,14.943,5.963Z" transform="translate(-4.262)" fill="#3e5463"/>
              <path id="Path_121" data-name="Path 121" d="M30.943,5.963c-1.428,1.191-1.038,2.4-.251,2.4a.7.7,0,0,0,.7-.7c0-.641,1.393-.843,1.393-2.32,0-1.86-2.354-1.783-.947-2.954S32.88,0,32.086,0a.7.7,0,0,0-.7.7c0,.641-1.393.843-1.393,2.32S31.389,4.7,31.389,5.343C31.389,5.573,31.278,5.684,30.943,5.963Z" transform="translate(-9.117)" fill="#3e5463"/>
            </g>
          </svg>
        </button>

        <div class="flex justify-center items-center text-[#3E5463]"> -<span class="hidden sm:flex justify-center">----</span> </div>

        <button type="button" :class="['border-0 outline-0 flex justify-center items-center size-[52px] rounded-[9px]', status !== 1 && status !== 2 && status !== 3 ? 'bg-[#C1D5E5]' : 'bg-transparent']" @click="status = 4">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="31" viewBox="0 0 32 31">
            <g id="Group_65" data-name="Group 65" transform="translate(0 0)">
              <g id="Ellipse_12" data-name="Ellipse 12" transform="translate(0 0)" fill="none" stroke="#3e5463" stroke-width="2">
                <ellipse cx="16" cy="15.5" rx="16" ry="15.5" stroke="none"/>
                <ellipse cx="16" cy="15.5" rx="15" ry="14.5" fill="none"/>
              </g>
              <path id="Path_122" data-name="Path 122" d="M35.714,24.111l-9.275,9.275a1.224,1.224,0,0,1-1.744,0l-4.328-4.328a1.233,1.233,0,0,1,1.744-1.744l3.457,3.45,8.4-8.4a1.233,1.233,0,1,1,1.744,1.744Z" transform="translate(-12.055 -12.051)" fill="#3e5463"/>
            </g>
          </svg>
        </button>

      </div>
    </div>
    <template v-if="status === 1 || status === 2">
      <div class="px-[16px] mb-[19px]">
        <div class="w-full font-bold flex justify-center items-center h-[52px] text-white rounded-[8px]" :class="{ 'bg-[#3E5463]' : status === 1, 'bg-[#C3785F]' :status === 2 }">
        <div class="mt-[4px]">
          <template v-if="status === 1"> {{lang === 'en' ? 'You are out of range' : 'أنت خارج النطاق'}} </template>
          <template v-if="status === 2"> {{lang === 'en' ? 'I arrived' : 'وصلت'}} </template>
        </div>
      </div>
    </div>
    </template>
<!-- when have button h-[404px], when don't have button h-[475px] -->
  <div class="px-[16px]">
    <div class="bg-white w-full h-full pt-[32px] px-[27px] rounded-t-[17px] scrollbar" :class="{ 'max-h-[423px]' : status === 1, 'max-h-[494px]' : status === 2 }">
    <div class="font-bold text-[15px] text-[#3E5463] uppercase"> {{lang === 'en' ? 'Your Order' : 'طلبك'}} </div>
    <div class="font-bold text-[15px] text-[#3E5463] uppercase"> {{lang === 'en' ? 'ORDER' : 'طلب'}} # 11668455 </div>
    <div class="font-bold text-[15px] text-[#3E5463] uppercase mb-[8.5px]"> 2022-07-04 </div>
    <div class="w-full bg-[#C6A798] h-[2px]"></div>
    <div class="my-[15.8px]">
      <div class="w-full text-[#3E5463] font-bold flex justify-between items-center text-[12px] sm:text-[16px]">
        <div class="flex justify-start items-center">
          <div class="w-[16px]"> 3 </div>
          <div class="w-[155px]"> <div class="truncate-to-1-line">  {{lang === 'en' ? 'NAI LEMON ORANGE' : 'ناي ليمون برتقال'}} </div> </div>
        </div>
        <div>
          33.00 {{lang === 'en' ? 'Sar' : '﷼'}}
        </div>
      </div>
      <div class="w-full text-[#3E5463] font-bold flex justify-between items-center text-[12px] sm:text-[16px]">
        <div class="flex justify-start items-center">
          <div class="w-[16px]"> 3 </div>
          <div class="w-[155px]"> <div class="truncate-to-1-line">  {{lang === 'en' ? 'NAI LEMON ORANGE' : 'ناي ليمون برتقال'}} </div> </div>
        </div>
        <div>
          33.00 {{lang === 'en' ? 'Sar' : '﷼'}}
        </div>
      </div>
      <div class="w-full text-[#3E5463] font-bold flex justify-between items-center text-[12px] sm:text-[16px]">
        <div class="flex justify-start items-center">
          <div class="w-[16px]"> 3 </div>
          <div class="w-[155px]"> <div class="truncate-to-1-line">  {{lang === 'en' ? 'NAI LEMON ORANGE' : 'ناي ليمون برتقال'}} </div> </div>
        </div>
        <div>
          33.00 {{lang === 'en' ? 'Sar' : '﷼'}}
        </div>
      </div>
    </div>
    <div class="w-full bg-[#C6A798] h-[2px]"></div>
    <div class="my-[15.8px]">
      <div class="flex justify-end mb-[7.1px]">
        <div class="w-full text-[#3E5463] font-bold flex justify-end items-center text-[12px] sm:text-[16px]">
          <div>
            {{lang === 'en' ? 'Products Value' : 'قيمة المنتجات'}}
          </div>
          <div class="w-[120px] text-end px-[8.5px]">
            33.00 {{lang === 'en' ? 'Sar' : '﷼'}}
          </div>
        </div>
      </div>
      <div class="flex justify-end mb-[7.1px]">
        <div class="w-full text-[#3E5463] font-bold flex justify-end items-center text-[12px] sm:text-[16px]">
          <div>
            {{lang === 'en' ? 'VAT (15%)' : 'ضريبة القيمة المضافة (15%)'}}
          </div>
          <div class="w-[120px] text-end px-[8.5px]">
            14.85 {{lang === 'en' ? 'Sar' : '﷼'}}
          </div>
        </div>
      </div>
      <div class="flex justify-end mb-[7.1px]">
        <div class="w-full text-[#3E5463] font-bold flex justify-end items-center text-[12px] sm:text-[16px]">
          <div>
            {{lang === 'en' ? 'Delivery' : 'توصيل'}}
          </div>
          <div class="w-[120px] text-end px-[8.5px]">
            15.00 {{lang === 'en' ? 'Sar' : '﷼'}}
          </div>
        </div>
      </div>
      <div class="flex justify-end mb-[7.1px]">
        <div class="w-full text-[#3E5463] font-bold flex justify-end items-center text-[12px] sm:text-[16px]">
          <div>
            {{lang === 'en' ? 'Delivery VAT (15%)' : 'ضريبة القيمة المضافة على التوصيل (15%)'}}
          </div>
          <div class="w-[120px] text-end px-[8.5px]">
            2.25 {{lang === 'en' ? 'Sar' : '﷼'}}
          </div>
        </div>
      </div>
      <div class="flex justify-end mb-[7.1px]">
        <div class="flex justify-end border-[2px] border-[#C6A798] text-[12px] sm:text-[16px]">
          <div class="w-[100px] sm:w-[125px] text-end py-[9.5px] text-[#3E5463] font-bold">
            {{lang === 'en' ? 'Total' : 'المجموع'}}
          </div>
          <div class="w-[120px] text-end px-[7.5px] py-[9.5px] text-[#3E5463] font-bold">
            131.01 {{lang === 'en' ? 'Sar' : '﷼'}}
          </div>
        </div>
      </div>
    </div>
    <div class="sm:max-w-[166px] mb-[14px] w-full mx-auto text-[12px] font-normal text-[#3E5463] text-center">
      {{lang === 'en' ? 'Thank you for ordering with Abu Helal Prices include 15% VAT' : 'شكرا لطلبك مع ابو هلال الاسعار تشمل 15% ضريبة القيمة المضافة'}}
    </div>
    <div class="sm:max-w-[166px] mb-[20px] w-full mx-auto text-[12px] font-normal text-[#3E5463] text-center">
      {{lang === 'en' ? 'Name of company:' : 'اسم الشركة:'}} Abu Helal <br/>
      {{lang === 'en' ? 'VAT Number:' : 'رقم ضريبة القيمة المضافة:'}} 565656563200003 <br/>
      {{lang === 'en' ? 'Commercial Registration Number:' : 'رقم السجل التجاري:'}} 4301666566433
    </div>
  </div>
  </div>
  </div>

</template>

<script>

export default {
  data(){
    return {
      lang: window?.core?.lang,
      status: 1,
    }
  },
  mounted() {

  },
  methods: {

  }
}

</script>